/**
 * Registers the one Trusted Types policy this app needs, matching the CSP's
 * `require-trusted-types-for 'script'; trusted-types caffeina;`. The only
 * dynamic script URL this app ever sets is the Matomo tracker (analytics.ts)
 * — the allowlist is deliberately that specific single URL rather than a
 * blanket pass-through, so this stays meaningful defense-in-depth rather than
 * a rubber stamp.
 *
 * Browsers without Trusted Types support (Firefox, Safari) ignore the CSP
 * directive entirely and never call this, which is why it is written
 * defensively rather than assumed to run.
 */
const ALLOWED_SCRIPT_URL = 'https://a.caffeina-ba.com/matomo.js';

interface ScriptUrlPolicy {
  createScriptURL(input: string): TrustedScriptURL;
}

let policy: ScriptUrlPolicy | undefined;

export function getTrustedScriptURL(url: string): string | TrustedScriptURL {
  if (url !== ALLOWED_SCRIPT_URL) {
    throw new Error(`URL de script no permitida por la política de Trusted Types: ${url}`);
  }

  if (typeof window === 'undefined' || !window.trustedTypes) {
    return url;
  }

  if (!policy) {
    policy = window.trustedTypes.createPolicy('caffeina', {
      createScriptURL: (input: string) => input,
    });
  }

  return policy.createScriptURL(url);
}
